import { render, staticRenderFns } from "./packageEdit.vue?vue&type=template&id=e37ec28e"
import script from "./packageEdit.vue?vue&type=script&lang=js"
export * from "./packageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports